import React from 'react';

class Footer extends React.Component {
    render() {
      return (
        <footer>
            <div className="container">
                <div className="copyright">
                    © 2019 Vodafone Group
                </div>
            </div>
        </footer>
      );
    }
  }

  export default Footer;